export const API = {
	flaggaAdminUrl: process.env.VITE_FLAGGA_ADMIN_BASE_URL,
};
